import {
  LetterbookType,
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import Text from "hardcover-ui/components/Text";
import { secondsFormat } from "lib/bookUtils";
import LetterbookCell from "../LetterbookCell";

export default function AudioLengthColumn({
  letterbook,
}: {
  letterbook: LetterbookType;
}) {
  const { book } = letterbook;
  const length = book.audioSeconds ? secondsFormat(book.audioSeconds) : null;

  return (
    <LetterbookCell className="font-bold text-xl">
      <span className="flex items-center">
        {length ? (
          <span>{length}</span>
        ) : (
          <Text variant="secondary" size="sm">
            Unknown
          </Text>
        )}
      </span>
    </LetterbookCell>
  );
}

export const settings = {
  key: "AudioLength",
  title: "Audio Length",
} as LetterlistTableColumnSettingType;
